exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.roomCardValue {\n  margin-right: 15px;\n}\ntable.scrolling td,\ntable.scrolling th {\n  max-width: 100% !important;\n}\n", ""]);

// exports
